import { useAppSelector } from '../../store/hooks'
import { selectAuthErrors } from '../../store/auth/authSlice'
import React, { useEffect, useRef } from 'react'
import { Toast } from 'primereact/toast'
import { ERROR_INVITE_CODE_EXPIRED, ERROR_INVITE_CODE_EXPIRED_AND_RESENT } from '../../common/errorCodes'

// errors with below errorCodes are being handled differently: toast message should be ignored, as we have specific
// error screens for them
const ignoredErrorCodes = [ERROR_INVITE_CODE_EXPIRED, ERROR_INVITE_CODE_EXPIRED_AND_RESENT]

export const AuthErrorToast: React.FC = () => {
  const authErrors = useAppSelector(selectAuthErrors)
  const toastRef = useRef<Toast>(null)

  useEffect(() => {
    const error = authErrors?.filter((error) => !ignoredErrorCodes.includes(error.errorCode)).find((error) => error.message)?.message
    if (!error) {
      return
    }
    toastRef.current &&
      toastRef.current.show({
        severity: 'error',
        summary: 'Error',
        detail: (
          <div>
            Unable to complete the operation, reason: {error}. If the issue persists, please contact us at{' '}
            <a href='mailto:support@zocks.io' target='_blank' rel='noreferrer'>
              support@zocks.io
            </a>
          </div>
        ),
        life: 10000,
      })
  }, [authErrors])

  return <Toast ref={toastRef} />
}
